import { NGCConfiguration, NGCFlow } from '~/types/recommendation';
import { ProductRecommendationResponse } from '~/types/recommendation/single-recommendation';
import {
  ActionTypes,
  SetRecommendationAction,
  SetRecommendationsAction,
  SetVASRecommendationsAction,
  SetSelectedRecommendationAction,
  SetRecommendationFlowAction,
  SetViewDetailsRecommendationAction,
  SetNGCConfigurationAction,
} from '~/types/recommendation/';
import { Recommendation } from '~/types/recommendation/multi-recommendation';

export const setRecommendationFlow = (recommendationFlow: NGCFlow): SetRecommendationFlowAction => {
  return { type: ActionTypes.SET_RECOMMENDATION_FLOW, recommendationFlow };
};

export const setRecommendation = (productRecommendation: ProductRecommendationResponse): SetRecommendationAction => {
  return { type: ActionTypes.SET_RECOMMENDATION, productRecommendation };
};

export const setRecommendations = (recommendations: Recommendation[]): SetRecommendationsAction => {
  return { type: ActionTypes.SET_RECOMMENDATIONS, recommendations };
};

export const setSelectedRecommendation = (recommendationId: string): SetSelectedRecommendationAction => {
  return { type: ActionTypes.SET_SELECTED_RECOMMENDATION, recommendationId };
};

export const setViewDetailsRecommendation = (recommendationId: string): SetViewDetailsRecommendationAction => {
  return { type: ActionTypes.SET_VIEW_DETAILS_RECOMMENDATION, recommendationId };
};

export const setNGCConfiguration = (ngcConfiguration: NGCConfiguration): SetNGCConfigurationAction => {
  return { type: ActionTypes.SET_NGC_CONFIGURATION, ngcConfiguration };
};

export const setVASRecommendations = (vasRecommendations: string[]): SetVASRecommendationsAction => {
  return { type: ActionTypes.SET_VAS_RECOMMENDATIONS, vasRecommendations };
};
